import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const ConstructorRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const designParam = searchParams.get('design');

  useEffect(() => {
    if (!designParam) {
       // If accessed /constructor without design, redirect to catalog
       navigate('/games/memory'); 
       return;
    }

    const fetchDesign = async () => {
      try {
        const res = await fetch('/api/public/games');
        if (!res.ok) throw new Error('Failed to load designs');
        const json = await res.json();
        const games = json.data?.games || [];
        
        const target = designParam.trim().toLowerCase();
        
        // Find design: match name or title case-insensitive
        const found = games.find((g: any) => {
            const name = (g.name || '').trim().toLowerCase();
            const title = (g.title || '').trim().toLowerCase();
            return name === target || title === target; // exact match (case insensitive)
        });
        
        if (found) {
           const designId = found.name || found.title;
           
           // Store design in localStorage to simulate selection from catalog
           try {
             localStorage.setItem(`selectedDesign_${designId}`, JSON.stringify(found));
           } catch (e) {
             console.warn('Failed to save design to localStorage', e);
           }
           
           const type = found.gameType || 'memory';
           
           const newParams = new URLSearchParams(searchParams);
           newParams.set('designId', designId);
           newParams.delete('design'); 
           
           // Normalize type for URL specifically if needed
           let normalizedType = (type || '').toLowerCase();
           // Basic mapping handled by Router keys, but ensuring consistency
           if (normalizedType === 'photopuzzle') normalizedType = 'photo-puzzle'; 
           
           navigate(`/constructor/${normalizedType}?${newParams.toString()}`, { replace: true });
        } else {
           setError(`Design "${designParam}" not found.`);
        }
      } catch (e) {
        console.error(e);
        setError('Error loading designs.');
      }
    };
    
    fetchDesign();
  }, [designParam, navigate, searchParams]);

  if (error) return (
    <div style={{ padding: 40, textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h3 style={{ color: '#d32f2f' }}>Error</h3>
      <p>{error}</p>
      <button 
        onClick={() => navigate('/games/memory')}
        style={{
          marginTop: 20,
          padding: '10px 20px',
          background: '#1976d2',
          color: 'white',
          border: 'none',
          borderRadius: 4,
          cursor: 'pointer'
        }}
      >
        Go to Games Catalog
      </button>
    </div>
  );
  
  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', color: '#666' }}>
      Identifying game type...
    </div>
  );
};
